	/**
	 * @ngdoc service
	 * @name WebCoreModule.service:WcTranslateConfiguratorService
	 * @requires $translateProvider
	 * @description
	 * The WcTranslateConfiguratorService allows WebCore to wrap default translation configuration with a construct that is still
	 * accessible in a module's .config() function. This provider also exposes a service, allowing for runtime configuration adjustment.
	 */
	/**
	 * @ngdoc service
	 * @name WebCoreModule.service:WcTranslateConfiguratorServiceProvider
	 * @requires $translateProvider
	 * @description
	 * The WcTranslateConfiguratorService allows WebCore to wrap default translation configuration with a construct that is still
	 * accessible in a module's .config() function. This provider also exposes a service, allowing for runtime configuration adjustment.
	 */

angular.module('WebCoreModule').provider('WcTranslateConfiguratorService', ['$translateProvider', function($translateProvider) {

	//expose the translate provider in case users need to call through to it
	this.translateProvider = $translateProvider;

	this.configuration = {
		sanitizationStrategy: 'escape',
		loader: '$translatePartialLoader',
		loaderObj: {urlTemplate: 'translations/{lang}/{part}.json'},
		langKeyArray: ['en', 'zh', 'ru'],
		langKeyObj: {
			'en_*': 'en',
			'en-*': 'en',
			'zh_CN': 'zh',
			'zh_HK': 'zh',
			'ru_RU': 'ru'
		},
		fallbackLang: 'en'
	};

	/**
	 * @ngdoc method
	 * @name WcTranslateConfiguratorServiceProvider.configureTranslateService
	 * @methodOf WebCoreModule.service:WcTranslateConfiguratorServiceProvider
	 * @param {Object} config Options object to configure default values used by the WcTranslateConfiguratorServiceProvider. Config properties that can be set in this object include:
	 *  - loader: String to identify the loader service to use. Defaults to '$translatePartialLoader' and likely does not need to be changed.
	 *  - loaderObj: Object defining loader configuration. Defaults to '{urlTemplate: 'translations/{lang}/{part}.json'}', defining the default location of translation json files.
	 *  - langKeyArray: Array of strings defining the languages the app should support. Defaults to ['en', 'zh', 'ru'].
	 *  - langKeyObj: Object defining mappings between two and four character language codes. Should define mappings for any languages in use.
	 *  - fallbackLang: String identifying the language to use if a non-supported language is requested. Defaults to 'en'
	 * @description
	 * The WcTranslateConfiguratorServiceProvider configures itself with application-wide defaults when it starts up. The configureDefaults function allows
	 * you to override those defaults at the app level, so that the new parameters will apply to the configuration of the translation modules.
	 */
	this.configureTranslateService = function(config) {
		//default config is set - if different config is passed in, use it instead
		if(config) {
			angular.extend(this.configuration, config);
		}
		$translateProvider.useSanitizeValueStrategy(this.configuration.sanitizationStrategy);
		$translateProvider.useLoader(this.configuration.loader, this.configuration.loaderObj);
		$translateProvider.registerAvailableLanguageKeys(this.configuration.langKeyArray, this.configuration.langKeyObj);
		$translateProvider.determinePreferredLanguage();
		$translateProvider.fallbackLanguage(this.configuration.fallbackLang);
		$translateProvider.use($translateProvider.preferredLanguage());
	};

	//this is essentially a factory function
	this.$get = ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader){
	/**
	 * @ngdoc method
	 * @name WcTranslateConfiguratorService.loadPartAndRefresh
	 * @methodOf WebCoreModule.service:WcTranslateConfiguratorService
	 * @param {String} partString String defining the language partial file to load. For instance, to load the JabUiApp.json file, pass in 'JabUiApp'
	 * @description
	 * The WcTranslateConfiguratorService exposes a helper function to add a language partial json file to the language database
	 * and refresh the application using it.
	 */
		this.loadPartAndRefresh = function(partString) {
			$translatePartialLoader.addPart(partString);
			$translate.refresh();
		};

		//return our object when all is said and done
		return this;
	}];
}]);